import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import {
  Box,
  Button,
  MobileStepper,
  Step,
  StepLabel,
  Stepper,
  Theme,
} from '@mui/material'
import DarkModeButton from '../DarkModeButton/DarkModeButton';

const ContentStepper = ({
  activeStep,
  setActiveStep,
  steps,
  isMobileDevice,
  theme,
  toggleDarkMode
}: {
  activeStep: number;
  setActiveStep: (value: number) => void;
  steps: string[];
  isMobileDevice: boolean;
  theme: Theme;
  toggleDarkMode: () => void;
}) => {
  const handleNextStep = (index: number) => setActiveStep(index)

  return isMobileDevice ? (
    <MobileStepper
      variant="progress"
      steps={steps.length + 1}
      position="static"
      activeStep={activeStep}
      nextButton={
        <Button
          size="small"
          onClick={() => handleNextStep(activeStep + 1)}
          disabled={activeStep === steps.length}
        >
          Próx.
          {theme.direction === 'rtl' ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </Button>
      }
      backButton={
        <Button
          size="small"
          onClick={() => handleNextStep(activeStep - 1)}
          disabled={activeStep === 0}
        >
          {theme.direction === 'rtl' ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
          Ant.
        </Button>
      }
    />
  ) : (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      height="100%"
      width={'15%'}
    >
      <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"} height={"100%"}>
        <Box display={"flex"} justifyContent={"flex-end"}>
          <DarkModeButton toggleDarkMode={toggleDarkMode} theme={theme} />
        </Box>

        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} height={"100%"}>
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((element, index) => (
              <Step key={element} onClick={() => handleNextStep(index)}>
                <StepLabel style={{
                  cursor: "pointer"
                }}>{element}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Box>
    </Box>
  )
}

export default ContentStepper
